// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__23can","insightsList":"newBusinessInsightsMenu_insightsList__3JLsZ","active":"newBusinessInsightsMenu_active__2TStb"};